<template>
  <div>
    <v-dialog v-model="dialogCategory" max-width="60%">
      <Category
          :categoryId="currentCategoryId"
          ref="category"
          @close="dialogCategory = false"
          @reload="reloadCategories"
      >
      </Category>
    </v-dialog>

    <v-dialog v-model="dialogCourseGroup" max-width="70%">
      <CourseGroup
          :courseId="null"
          ref="courseGroup"
          @close="dialogCourseGroup = false"
          @reload="reloadCourseGroup"
      >
      </CourseGroup>
    </v-dialog>

    <v-container
        style="max-width: unset; "
        class=" pt-2 ma-0"
    >
      <HeaderOrders
          :arrow="false"
          title="Gerenciamento de Cursos e Combos"
          text="Funcionalidade para gerenciar cursos e combos, permitindo cadastrar, listar, editar e excluir registros. Também possibilita criar e manter combos personalizados que agrupam vários cursos."
          :haveAction="true"
          actionTitle="Novo Pedido"
      >
      </HeaderOrders>
      <v-card elevation="1" style="margin-top: 0px" class=" ">
        <v-row cols="12" justify="end" class="pr-3 pb-3">
          <v-btn
              v-if="activeTab == 0"
              elevation="0"
              class="primary-button mr-2"
              @click="goToRoute('/cursos-cadastrar')"
          >
            Cadastrar curso
          </v-btn>

          <v-btn
              v-if="activeTab == 1"
              elevation="0"
              class="primary-button mr-2"
              @click="showDialogCourseGroup()"
          >
            Cadastrar turma
          </v-btn>

          <v-btn
              v-if="activeTab == 2"
              elevation="0"
              class="primary-button mr-2"
              @click="goToRoute('/combos-cadastrar')"
          >
            Cadastrar combo
          </v-btn>
          <v-btn
              v-if="activeTab == 3"
              elevation="0"
              class="primary-button mr-2"
              @click="dialogCategory = true"
          >
            Cadastrar categoria
          </v-btn>
        </v-row>
      </v-card>

      <v-card elevation="1" style="margin-top: 0; margin-bottom: 0" class=" ">
        <v-tabs
            v-model="activeTab"
            class="px-0"
            background-color="#ECEEF1"
            grow
            height="55"
            hide-slider
        >
          <v-tab
              :value="0"
              active-class="active-tab"
              class="tab"
              style="font-weight: bold !important"
              @click="activeTab = 0"
          >
            <span>Cursos</span>
          </v-tab>
          <v-tab
              :value="1"
              active-class="active-tab"
              class="tab"
              style="font-weight: bold !important"
              @click="activeTab = 1"
          >
            <span>Turmas</span>
          </v-tab>
          <v-tab
              :value="2"
              active-class="active-tab"
              class="tab"
              @click="activeTab = 2"
          >
            <span>Combos</span>
          </v-tab>
          <v-tab
              :value="3"
              active-class="active-tab"
              class="tab"
              @click="activeTab = 3"
          >
            <span>Categorias</span>
          </v-tab>
        </v-tabs>
      </v-card>

      <v-tabs-items v-model="activeTab">
        <v-tab-item v-if="activeTab == 0" :value="0">
          <Courses></Courses>
        </v-tab-item>
        <v-tab-item v-if="activeTab == 1" :value="1">
          <CourseGroups></CourseGroups>
        </v-tab-item>
        <v-tab-item v-if="activeTab == 2" :value="2">
          <Combos></Combos>
        </v-tab-item>
        <v-tab-item v-if="activeTab == 3" :value="3">
          <Categories></Categories>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>


import Courses from "./components/Courses.vue";
import HeaderOrders from "@/views/pages/Orders/components/HeaderOrders.vue";
import Combos from "@/views/pages/Courses/components/Combos.vue";
import Categories from "@/views/pages/Courses/components/Categories.vue";
import Category from "@/views/pages/Courses/components/Category.vue";
import CourseGroups from "@/views/pages/Courses/components/CourseGroups.vue";
import CourseGroup from "@/views/pages/Courses/components/CourseGroup.vue";

export default {
  name: 'Index',
  components: {
    CourseGroup,
    CourseGroups,
    Category,
    Categories,
    Combos,
    HeaderOrders,
    Courses
  },

  data() {
    return {
      dialogCourseGroup: false,
      activeTab: 0,
      dialogCategory: false,
      currentCategoryId: null,
    }
  },

  created() {

  },

  methods: {
    async goToRoute(route) {
      await this.$router.push(route);
    },

    reloadCategories(){
      this.activeTab = 3
    },
    reloadCourseGroup(){
      this.activeTab = 1
    },

    showDialogCourseGroup(){
      this.dialogCourseGroup = true
    }
  },
};
</script>
<style lang='scss' scoped>
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}
</style>
